import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Form, Input, FormInstance } from 'antd';
import { TextEditor } from 'ui';

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};

interface ActivityTabInterface {
    language: string;
    form: FormInstance;
    activityId: number;
    viewMaterial?: any;
    onCancel: any;
    reload: Function;
    settings: any;
    setSettings: Function
}

const ActivityTab: React.FC<ActivityTabInterface> = ({
    language,
    form,
    activityId,
    viewMaterial,
    onCancel,
    reload,
    settings,
    setSettings
}) => {
    const intl = useIntl();

    return (
        <>
            <h3><FormattedMessage id='assessment.title_and_description' /></h3>
            <Form.Item required={true} {...formItemLayout} name='title' label={intl.formatMessage({ id: 'general.title' })} >
                <Input />
            </Form.Item>
            <Form.Item {...formItemLayout} label={intl.formatMessage({ id: 'general.description' })}>
                <TextEditor
                    initial={settings.description ?? ''}
                    setHtmlOutput={(value: any) => setSettings((prev: any) => ({
                        ...prev,
                        description: value ?? ''
                    }))}
                />
            </Form.Item>
        </>
    )
}
export default ActivityTab;
